var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"round_msg"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.message.title1))]),_c('p',[_vm._v(_vm._s(_vm.message.Para))]),_c('router-link',{attrs:{"to":{name:_vm.message.Link}}},[_vm._v(" "+_vm._s(_vm.message.button)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }